export default __webpack_public_path__ + "static/media/grayYoutube.0436f109.svg";